export const mainBannerComerciales = [
    {
        image: '/assets/imgs/services/industriales/fondo.png',
        color: '#FFCD00',
        text: 'SERVICIOS<br/><span>COMERCIALES</span>',
      }

];

export const mainBannerComercialesEn = [
    {
        image: '/assets/imgs/services/industriales/fondo.png',
        color: '#FFCD00',
        text: '<h5>COMMERCIAL</h5><h3>SERVICES</h3>',
      }
];